export default function Example({ message }) {
  return (
    <div>
      <h1>Inertia Example Page</h1>
      <p>{message || 'Hello from Inertia.js!'}</p>
    </div>
  )
}
